import React, { useState } from 'react';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  AppBar,
  Toolbar,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import KastLogo from '../NewKast.png';

const drawerWidth = 240;

const navItems = [
  { label: 'Feed', path: '/home' },
  { label: 'My Saves', path: '/saves' },
  // { label: 'People', path: '/people' },  
  { label: 'Settings', path: '/settings' },  
  { label: 'About', path: '/about' },
];

export default function Layout({ children }) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box
      sx={{
        width: drawerWidth,
        backgroundColor: '#fefaf5',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        //borderRight: '1px solid #e0e0e0' // Added right border
      }}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mb: 2,
          pt: 3,
          px: 2 
        }}
      >
        <img
          src={KastLogo}
          alt="Kast Logo"
          style={{ 
            maxWidth: '100%', 
            height: 50, 
            cursor: 'pointer',
            padding: '8px 0'
          }}
          onClick={() => navigate('/')}
        />
      </Box>

      <List sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        {navItems.map((item) => (
          <ListItem
            key={item.path}
            button
            component={Link}
            to={item.path}
            selected={location.pathname === item.path}
            sx={{
              color: '#74706B', // Changed to dark grey
              //borderRadius: '8px',
              mx: 1,
              mb: 0.5,
              '&.Mui-selected': {
                backgroundColor: '#FF890A',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#FF890A',
                },
              },
              '&:hover': {
                backgroundColor: 'rgba(255, 137, 10, 0.1)',
                //borderRadius: '8px' // Ensures symmetrical radius on hover
              },
            }}
            onClick={() => setMobileOpen(false)}
          >
            <ListItemIcon sx={{ 
              color: 'inherit',
              minWidth: '40px',
              '&.Mui-selected': {
                color: 'white',
              },
            }} />
            <ListItemText 
              primary={item.label} 
              primaryTypographyProps={{
                fontWeight: location.pathname === item.path ? 'bold' : 'normal',
                fontSize: '1.1rem' // Increased text size by ~2 units
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex'}}>
      {isMobile ? (
        <>
          <AppBar 
            //position="fixed" 
            sx={{               
              backgroundColor: '#fefaf5', 
              color: '#74706B', // Changed to dark grey
              boxShadow: 'none',              
              //borderBottom: '1px solid #e0e0e0'                            
            }}
          >
            <Toolbar sx={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              padding: '0 16px',
              minHeight: '64px !important',                      
            }}>
              <img
                src={KastLogo}
                alt="Kast Logo"
                style={{ 
                  height: 40, 
                  cursor: 'pointer',
                  padding: '8px 0'
                }}
                onClick={() => navigate('/')}
              />
              <IconButton 
                edge="end" 
                color="inherit" 
                onClick={toggleDrawer}
                sx={{ padding: '8px', color: '#74706B' }} // Changed to dark grey
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          <Drawer
            anchor="right"
            open={mobileOpen}
            onClose={toggleDrawer}
            ModalProps={{ 
              keepMounted: true,
              BackdropProps: {
                sx: {
                  backgroundColor: 'rgba(0,0,0,0.1)'
                }
              }
            }}
            sx={{
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                //boxSizing: 'border-box',
              },
            }}
          >
            {drawer}
          </Drawer>

          <Box component="main" sx={{ 
            flexGrow: 1, 
            p: 3, 
            mt: 8,
            width: '100%',
            overflowX: 'hidden'
          }}>
            {children}
          </Box>
        </>
      ) : (
        <>
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                //boxSizing: 'border-box',
                backgroundColor: '#fefaf5',
                borderRight: '1px solid blak', // Added right border
              },
            }}
            variant="permanent"
            anchor="left"
          >
            {drawer}
          </Drawer>
          <Box component="main" sx={{ 
            flexGrow: 1, 
            p: 3,
            width: `calc(100% - ${drawerWidth}px)`,
            overflowX: 'hidden'
          }}>
            {children}
          </Box>
        </>
      )}
    </Box>
  );
}